import { render, staticRenderFns } from "./formulator-salt-selection.vue?vue&type=template&id=82df3708&"
import script from "./formulator-salt-selection.vue?vue&type=script&lang=js&"
export * from "./formulator-salt-selection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports